var _defs, _path, _path2, _circle, _line, _line2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearTextFieldsX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 414.35 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#5c5858;}.cls-1,.cls-2{fill-rule:evenodd;}.cls-2{fill:#858282;}.cls-3{fill:none;stroke:#9c433e;stroke-miterlimit:10;stroke-width:20px;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m127.73,175.11h0M81.55,0h251.65c22.3,0,42.62,9.1,57.27,23.89,14.65,14.65,23.89,34.97,23.89,57.26v349.69c0,22.3-9.24,42.62-23.89,57.27-14.65,14.78-34.97,23.89-57.27,23.89H98.44l12.54-21.65h222.22c16.36,0,31.14-6.73,41.96-17.55,10.82-10.69,17.55-25.6,17.55-41.96V81.15c0-16.36-6.73-31.27-17.55-41.96-10.82-10.82-25.6-17.55-41.96-17.55H81.55c-16.36,0-31.27,6.73-42.09,17.55-10.69,10.69-17.42,25.6-17.42,41.96v223.4L.39,342.03V81.15C.39,58.85,9.5,38.53,24.15,23.89,38.93,9.1,59.25,0,81.55,0h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m127.34,174.85h0L0,395.49v116.26l50.28-29.03,50.41-29.17,127.34-220.5c16.1-27.84,6.6-63.34-21.24-79.44-27.85-16.09-63.34-6.59-79.44,21.25h0Zm-43.41,261.94l-40.25,23.22-20.72-12v-46.45l60.97,35.23Zm-55.03-45.52l96.2-166.67,60.97,35.1-96.2,166.8-60.97-35.23Zm108.34-187.52l10.03-17.41c9.63-16.77,31.14-22.57,48.03-12.8,16.76,9.63,22.56,31.14,12.8,48.03l-10.03,17.28-60.83-35.1Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 265.37,
    cy: 364,
    r: 108
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 186.5,
    y1: 288.28,
    x2: 339.45,
    y2: 441.23
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 338.77,
    y1: 288.96,
    x2: 187.18,
    y2: 440.55
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearTextFieldsX);
export default __webpack_public_path__ + "static/media/clear_text_fields_x.c92dc6010c3ec8c6d700abe52cdedcbc.svg";
export { ForwardRef as ReactComponent };